import React, { useEffect, useState } from 'react'
import AdminHeaderComponent from '../Components/AdminHeaderComponent';
import { scoreValueMappingResponse } from '../Types/AdminType';
import { getAllScoreValueMappingConfigByFieldName } from '../Services/AdminService';
import { useParams } from 'react-router-dom';
import ScoreMappingConfigComponent from '../Components/ScoreMappingConfigComponent';



function ScoreMappingConfigPage() {
  const [adminData, setAdminData] = useState<scoreValueMappingResponse []>([]);
      const [loading, setLoading] = useState<boolean>(true);
      const [error, setError] = useState<string>("");
      const { id } = useParams<{ id: string }>();
      
      useEffect(() => {
        const fetchCandidate = async () => {
          try {
            setLoading(true); // Ensure loading is true when starting
            const response = await getAllScoreValueMappingConfigByFieldName(id as string);
  
            console.log("Recruiters Response:", response);
      
            if (response.success) {
              setAdminData(response.data);
            } else {
              setError(response.message || "Could not retrieve recruiter profile.");
            }
          } catch (err) {
            setError("An unexpected error occurred while loading the profile.");
            console.error(err);
          } finally {
            setLoading(false);
          }
        };
      
        fetchCandidate();
      }, []); // Empty dependency array is fine if using localStorage
  
  
      const handleEdit = () => {
        // Implement the logic to edit the recruiter with the given ID and updated data
        console.log(`Edit recruiter with ID:` );
      }
  
      const handleDelete = (id: string) => {
        // Implement the logic to delete the recruiter with the given ID
        console.log(`Delete recruiter with ID: ${id}`);
      }

  return (
    <div>
      {/* <AdminHeaderComponent /> */}
      <ScoreMappingConfigComponent
       data={adminData} 
          onEditSubmit={handleEdit} 
          onDeleteConfirm={handleDelete} 
          onRegisterSubmit={handleEdit}
          menuName="Map Values"/>
    </div>
  )
}

export default ScoreMappingConfigPage